import useTranslate from "../../core/languages/hooks/useTranslate";
import BookingItem from "../types/BookingItem";
import React, {useMemo} from "react";
import {Alert} from "../../ui/shared/Alert/Alert";
import Badge from "../../ui/shared/Badge/Badge";

const OverbookingAlert: React.FC<{ bookingItems: BookingItem[] }> = ({bookingItems}) => {
    const t = useTranslate();

    const overbookingDates: string[] = useMemo(() => {
        if (!bookingItems) return [];

        const datesSet = new Set<string>();

        bookingItems.forEach(item => {
            item.overbookingDates?.forEach(date => datesSet.add(date));
        });

        return Array.from(datesSet);
    }, [bookingItems]);

    return (
        <Alert type="warning" closable={false}>
            <div className="flex flex-col gap-2">
                <p className="font-semibold">{t("bookOk.statusBookingOverbooking")}</p>
                <p>{t("bookOk.roomsWithOverbookingDisclaimer")}</p>
                <div className="flex flex-wrap gap-1 mt-1">
                    {overbookingDates.map(date => <Badge key={date} name={date} color="yellow"/>)}
                </div>
            </div>
        </Alert>
    );
};

export default OverbookingAlert;
